import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import './LoginRegister.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { LanguageContext } from "../context/LanguageContext";

const RegisterUser = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const status = query.get("status");
  const navigate = useNavigate();
  const [fieldErrors, setFieldErrors] = useState({});
  const [isPhoneCodeOpen, setIsPhoneCodeOpen] = useState(false);
  const [phoneCodeSearch, setPhoneCodeSearch] = useState("");
  const { language, texts } = useContext(LanguageContext);
 
  const [formData, setFormData] = useState({
    salutation: '',
    first_name: '',
    last_name: '',
    company_name: '',
    street: '',
    house_number: '',
    postal_code: '',
    town: '',
    country_id: '',
    phone_country_code: '',
    phone_number: '',
    terms_accepted: false,
    privacy_accepted: false,
  });

  const [error, setError] = useState('');
  const [countries, setCountries] = useState([]);
  const [salutation, setSalutation] = useState([]);

  const agbUrl = language === "en"
  ? "/docs/AGBs_Inserat_EN.pdf"
  : "/docs/AGBs_Inserat_DE.pdf";

  const privacyUrl = language === "en"
    ? "/docs/Datenschutz_EN.pdf"
    : "/docs/Datenschutz_DE.pdf";

  const filteredCountries = countries.filter(c =>
  (c.name + " " + c.phone_code)
    .toLowerCase()
    .includes(phoneCodeSearch.toLowerCase())
);
console.log("REGISTER USER URL:", window.location.href);

// Token aus URL übernehmen, DEKODIEREN und /me laden
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const tokenFromUrl = params.get("token");

  if (tokenFromUrl) {
    // Token speichern
    localStorage.setItem("authToken", tokenFromUrl);

    // Token DEKODIEREN
    try {
      const decoded = JSON.parse(atob(tokenFromUrl.split(".")[1]));

      if (decoded.profileIncomplete !== undefined) {
        localStorage.setItem("profileIncomplete", decoded.profileIncomplete);
        console.log("DECODED TOKEN:", decoded);
      }
    } catch (err) {
      console.error("Fehler beim Dekodieren des Tokens:", err);
    }

    // /me laden, um Profilstatus zu aktualisieren
    axios.get(`${process.env.REACT_APP_API_URL}/api/user/me`, {
      headers: { Authorization: `Bearer ${tokenFromUrl}` }
    })
    .then(res => {
      localStorage.setItem("profileIncomplete", res.data.profileIncomplete);
      console.log("ME RESPONSE:", res.data);
    })
    .catch(err => {
      console.error("Fehler beim Laden des Users nach Verify:", err);
    });
  }
}, [location.search]);

  // Länder laden
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/countries?lang=${language}`)
      .then(res => setCountries(res.data))
      .catch(() => setError(texts.contactEdit.errorLoading));
  }, [language, texts]);

  // Anreden laden
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/salutations?lang=${language}`)
      .then(res => setSalutation(res.data))
      .catch(() => setError(texts.contactEdit.errorLoading));
  }, [language, texts]);

  // Formulareingaben ändern
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData(prev => {
      let updated = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      // Wenn Land geändert wird → passende Vorwahl setzen
      if (name === "country_id") {
        const selectedCountry = countries.find(c => c.id === Number(value));
        if (selectedCountry) {
          updated.phone_country_code = selectedCountry.phone_code || "";
        }
      }

      return updated;
    });

    // Fehler entfernen
    setFieldErrors(prev => ({
      ...prev,
      [name]: false,
    }));
  };

  const handleSelectPhoneCode = (phoneCode) => {
  setFormData(prev => ({
    ...prev,
    phone_country_code: phoneCode,
  }));

  setFieldErrors(prev => ({
    ...prev,
    phone_country_code: false,
  }));

  setIsPhoneCodeOpen(false);
};

  // Formular absenden
const handleSubmit = async (e) => {
  e.preventDefault();

  setError(""); 
  let newErrors = {};
  let errorMessages = [];

  // Pflichtfelder prüfen
  const requiredFields = [
    "salutation", "first_name", "last_name", "street",
    "house_number", "postal_code", "town", "country_id",
    "phone_country_code", "phone_number"
  ];

  requiredFields.forEach(field => {
    if (!formData[field]) {
      newErrors[field] = true;
    }
  });

  if (Object.keys(newErrors).length > 0) {
    errorMessages.push("Bitte fülle alle Pflichtfelder aus.");
  }

  // AGB & Datenschutz prüfen
  if (!formData.terms_accepted) {
    newErrors.terms_accepted = true;
  }
  if (!formData.privacy_accepted) {
    newErrors.privacy_accepted = true;
  }

  if (!formData.terms_accepted || !formData.privacy_accepted) {
    errorMessages.push("Bitte akzeptiere die AGB und die Datenschutzbestimmungen.");
  }

  // Wenn Fehler vorhanden → anzeigen & abbrechen
  if (errorMessages.length > 0) {
    setFieldErrors(newErrors);
    setError(errorMessages.join(" "));
    return;
  }

  // Token holen
  const token = localStorage.getItem('authToken');
  if (!token) {
    setError("Bitte melde dich zuerst an.");
    navigate('/login');
    return;
  }

try {
  // Telefonnummer zusammensetzen (ohne Leerzeichen)
  const fullPhoneNumber =
    (formData.phone_country_code || "") +
    (formData.phone_number || "").replace(/\s+/g, "");

  // Neues Payload-Objekt für das Backend
  const payload = {
    ...formData,
    phone_number: fullPhoneNumber
  };

  // Vorwahl nicht mitsenden
  delete payload.phone_country_code;

  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/register-user`,
    payload,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  if (response.data.token) {
    localStorage.setItem("authToken", response.data.token);
  }

  if (response.data.user) {
    localStorage.setItem("user_id", response.data.user.id);
  }

  localStorage.setItem("profileIncomplete", response.data.profileIncomplete);

  if (response.data.profileIncomplete === false) {
    window.location.href = "/dashboard";
  } else {
    navigate("/register-user");
  }

} catch (err) {
  console.error("FEHLER IM REGISTER-USER REQUEST:", err);
  setError("Fehler beim Speichern der Benutzerdaten!");
}
}

return (
  <div className="register-container-user">
    <h2 className="register-header">{texts.registerUser.title}</h2>

    {status === "verified" && (
      <div className="success-message">
        {texts.registerUser.verifiedMessage}
      </div>
    )}

    {error && <div className="error-message">{error}</div>}

    <form className="register-form" onSubmit={handleSubmit}>

      {/* Anrede */}
      <div className="form-group">
        <label htmlFor="salutation">{texts.registerUser.salutation}</label>
        <select
          id="salutation"
          name="salutation"
          value={formData.salutation}
          onChange={handleChange}
          className={`form-input ${fieldErrors.salutation ? "input-error" : ""}`}
        >
          <option value="">{texts.registerUser.selectSalutation}</option>
          {salutation.map(s => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>
      </div>

      {/* Firma */}
      <div className="form-group">
        <label htmlFor="company_name">{texts.registerUser.company}</label>
        <input
          type="text"
          id="company_name"
          name="company_name"
          value={formData.company_name}
          onChange={handleChange}
          className="form-input"
        />
      </div>

      {/* Vorname */}
      <div className="form-group">
        <label htmlFor="first_name">{texts.registerUser.firstName}</label>
        <input
          type="text"
          id="first_name"
          name="first_name"
          value={formData.first_name}
          onChange={handleChange}
          className={`form-input ${fieldErrors.first_name ? "input-error" : ""}`}
        />
      </div>

      {/* Nachname */}
      <div className="form-group">
        <label htmlFor="last_name">{texts.registerUser.lastName}</label>
        <input
          type="text"
          id="last_name"
          name="last_name"
          value={formData.last_name}
          onChange={handleChange}
          className={`form-input ${fieldErrors.last_name ? "input-error" : ""}`}
        />
      </div>

      {/* Adresse */}
      <div className="form-group">
        <label htmlFor="street">{texts.registerUser.street}</label>
        <input
          type="text"
          id="street"
          name="street"
          value={formData.street}
          onChange={handleChange}
          className={`form-input ${fieldErrors.street ? "input-error" : ""}`}
        />
      </div>

      <div className="form-group">
        <label htmlFor="house_number">{texts.registerUser.houseNumber}</label>
        <input
          type="text"
          id="house_number"
          name="house_number"
          value={formData.house_number}
          onChange={handleChange}
          className={`form-input ${fieldErrors.house_number ? "input-error" : ""}`}
        />
      </div>

      <div className="form-group">
        <label htmlFor="postal_code">{texts.registerUser.postalCode}</label>
        <input
          type="text"
          id="postal_code"
          name="postal_code"
          value={formData.postal_code}
          onChange={handleChange}
          className={`form-input ${fieldErrors.postal_code ? "input-error" : ""}`}
        />
      </div>

      <div className="form-group">
        <label htmlFor="town">{texts.registerUser.town}</label>
        <input
          type="text"
          id="town"
          name="town"
          value={formData.town}
          onChange={handleChange}
          className={`form-input ${fieldErrors.town ? "input-error" : ""}`}
        />
      </div>

      {/* Land */}
      <div className="form-group">
        <label htmlFor="country_id">{texts.registerUser.country}</label>
        <select
          id="country_id"
          name="country_id"
          value={formData.country_id}
          onChange={handleChange}
          className={`form-input ${fieldErrors.country_id ? "input-error" : ""}`}
        >
          <option value="">{texts.registerUser.selectCountry}</option>
          {countries.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      {/* Telefon */}
      <div className="form-group">
        <label>{texts.registerUser.phone}</label>

        <div className="phone-flex">

          {/* Vorwahl */}
          <div
            className={`phone-code-dropdown ${fieldErrors.phone_country_code ? "input-error" : ""}`}
          >
            <button
              type="button"
              className="phone-code-toggle"
              onClick={() => {
                setIsPhoneCodeOpen(prev => !prev);
                setPhoneCodeSearch("");
              }}
            >
              {formData.phone_country_code || texts.registerUser.phoneCodePlaceholder}
              <span className="phone-code-arrow">▾</span>
            </button>

            {isPhoneCodeOpen && (
              <div className="phone-code-menu">

                <input
                  type="text"
                  className="phone-code-search"
                  placeholder={texts.registerUser.search}
                  value={phoneCodeSearch}
                  onChange={(e) => setPhoneCodeSearch(e.target.value)}
                  autoFocus
                />

                {filteredCountries.map((c) => (
                  <button
                    type="button"
                    key={c.id}
                    className="phone-code-option"
                    onClick={() => handleSelectPhoneCode(c.phone_code)}
                  >
                    {c.phone_code} {c.name}
                  </button>
                ))}

                {filteredCountries.length === 0 && (
                  <div className="phone-code-no-results">
                    {texts.registerUser.noResults}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Telefonnummer */}
          <input
            type="text"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            className={`form-input phone-number ${fieldErrors.phone_number ? "input-error" : ""}`}
            placeholder={texts.registerUser.phonePlaceholder}
          />
        </div>
      </div>

        {/* AGB */}
        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              name="terms_accepted"
              checked={formData.terms_accepted}
              onChange={handleChange}
              className={fieldErrors.terms_accepted ? "checkbox-error" : ""}
            />
            &nbsp;{texts.registerUser.terms}{" "}
            <a href={agbUrl} target="_blank" rel="noopener noreferrer">
              {texts.registerUser.termsLink}
            </a>
          </label>
        </div>

      {/* Datenschutz */}
      <div className="form-group checkbox-group">
        <label>
          <input
            type="checkbox"
            name="privacy_accepted"
            checked={formData.privacy_accepted}
            onChange={handleChange}
            className={fieldErrors.privacy_accepted ? "checkbox-error" : ""}
          />
          &nbsp;{texts.registerUser.privacy}{" "}
          <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
            {texts.registerUser.privacyLink}
          </a>
        </label>
      </div>

      <button type="submit" className="register-button">
        {texts.registerUser.save}
      </button>
    </form>
  </div>
);
};

export default RegisterUser;
